import React from 'react';
import { rdtTrack } from '@/lib/redditPixel';

/**
 * The App Store and Google Play badges, for download sections on the website.
 *
 * Props:
 *   lang  — 'en' | 'it'  (defaults to 'en')
 */
const AppDownload = ({ lang = 'en' }) => <StoreBadges lang={lang} />;

/* ── Store Badges ── */
// The last step we can see before an install: GA4 store_click + Reddit Lead.
const storeClick = (store) => {
  try { if (typeof window.gtag === 'function') window.gtag('event', 'store_click', { store }); } catch (e) { /* optional */ }
  rdtTrack('Lead', { customEventName: store });
};

const StoreBadges = ({ lang }) => {
  const isIT = lang === 'it';
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
      <a
        href="https://apps.apple.com/us/app/better-husband-relationships/id6758739606"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
        onClick={() => storeClick('AppStore')}
      >
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt={isIT ? 'Scarica su App Store' : 'Download on the App Store'}
          className="h-10"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.greathusband.app"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
        onClick={() => storeClick('GooglePlay')}
      >
        <img
          src={
            isIT
              ? 'https://play.google.com/intl/it_it/badges/static/images/badges/it_badge_web_generic.png'
              : 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
          }
          alt={isIT ? 'Disponibile su Google Play' : 'Get it on Google Play'}
          className="h-14"
        />
      </a>
    </div>
  );
};

export default AppDownload;
